import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdResource } from "../../../../constants/IdResource";
import { selectBalloonContentInfo, selectBalloonContentLevelType, } from "../../../../selectors/selectBalloonInfo";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
import { actionBeginBuyWithGoldProcess } from "../../../buy-with-gold/actionBuyWithGold";
import { actionBalloonOfferConsume, TypeActionBalloonInfo, } from "../actionBalloonInfo";
export var epicBalloonOfferBuyWithGold = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBalloonInfo.BuyWithGold), switchMap(function (action) {
        var state = state$.value;
        var playerGold = selectInventoryResourceInfo(state, IdResource.Gold).amount || Long.ZERO;
        var balloonOfferContent = selectBalloonContentInfo(state);
        var balloonOfferLevelType = selectBalloonContentLevelType(state, balloonOfferContent);
        var goldRequired = Long.ZERO;
        if (balloonOfferLevelType) {
            var cost = balloonOfferLevelType.cost;
            if (cost && cost.resourceId === IdResource.Gold) {
                goldRequired = Long.fromValue(cost.amount);
            }
        }
        return of(actionBeginBuyWithGoldProcess(playerGold, goldRequired, actionBalloonOfferConsume(action.balloonContentId)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/balloon/epics/epicBalloonOfferBuyWithGold.ts
// module id = 1898
// module chunks = 3